import React from 'react';
import { useTheme } from '../context/ThemeContext';
import iconTg1 from '../icons/tg-1.svg';
import iconX1 from '../icons/x-1.svg';

const Footer = () => {
  const { theme } = useTheme();
  
  return (
    <footer className="py-8 px-4" style={{ background: 'var(--section-bg)', color: 'var(--text-secondary)' }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          {/* Left side: Logo and text in different lines */}
          <div className="mb-4 md:mb-0">
            <div className="p-2 rounded-lg inline-block mb-2" style={{ background: 'var(--header-bg)' }}>
              <img
                src={theme === 'light' ? "/img/logo-light.png" : "/img/logo-dark.png"}
                className="h-16 w-auto"
                alt="FlazePad logo"
              />
            </div>
            <p className="text-sm">
              Launch Fast, Trade Instantly
            </p>
          </div>
          
          {/* Right side: X and TG in different lines */}
          <div className="flex flex-row gap-4">
            <a href="https://x.com/FlazePad" target="_blank" rel="noopener noreferrer">
              <img src={iconX1} className={`w-6 h-6 ${theme === 'light' ? 'filter invert' : ''}`} alt="X (Twitter)" />
            </a>
            <a href="https://t.me/FlazePad" target="_blank" rel="noopener noreferrer">
              <img src={iconTg1} className={`w-6 h-6 ${theme === 'light' ? 'filter invert' : ''}`} alt="Telegram" />
            </a>
          </div>
        </div>
        
        <div className="mt-8 text-center text-sm">
          <p>© 2026 FlazePad. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
